import React from 'react';
import GlobalHeader from '../Fragments/GlobalHeader';

let Quote = require('../Managers/Quote');
let globalConfig = require('Config');
let HttpService = require('../Managers/HttpService');

const envConfig = HttpService.getConfigForHost();

class ApplicationError extends React.Component {
    componentDidMount() {
        this.getIp('Error.ip');

        Quote.setByPath('Error.title', 'Application error');
        Quote.setByPath('Error.userAgent', window.navigator.userAgent);
        Quote.setByPath('Error.reference', Quote.getCurrentAnswer('policyNumber'));
        Quote.setByPath('Error.email', Quote.getCurrentAnswer('email_address'));

        this.logError(window.localStorage.getItem('Error'));
    }

    /**
     * Uses the config endpoint for getting the user agent IP to store it in
     * localStorage where required.
     *
     * @param saveTo
     */
    getIp(saveTo) {
        let url = globalConfig.ipLookup.url;

        $.getJSON(url, function(data) {
            Quote.setByPath(saveTo, data.ip);
        });
    }

    /**
     * Logs an error message though an API endpoint.
     *
     * @param message
     * @returns {Promise}
     */
    logError(message) {
        let errorData = {
            "msg": message,
            "app": "landlordInsuranceSPA"
        };

        return new Promise((resolve, reject) => {
            $.ajax({
                type: 'POST',
                data: JSON.stringify(errorData),
                url: envConfig.logging.postError.url,
                crossDomain: true,
                headers: {
                    "Content-Type": "application/json",
                    "X-API-KEY": envConfig.logging.postError.key,
                },
                success: function(data) {
                    resolve(data);
                },
                error: function() {
                    reject("FAILED LOGGING ERROR");
                }
            });
        });
    }

    render() {
        return (
            <div>
                <GlobalHeader />

                <div className="container stepless">
                    <h1>Application Error</h1>
                    <div className="form-group">
                        <div className="field-content">
                            <p>
                                We&rsquo;re sorry, an error has occurred.<br />
                                <br />
                                Our technical team have been notified.<br />
                            </p>
                            <p>Information relating to the error/s can be found below:</p>
                            <p>
                                If you wish to contact us about this error please email <a className="underline" href="mailto:homeletitservicedesk@homelet.co.uk">homeletitservicedesk@homelet.co.uk</a><br />
                                Alternatively you can find telephone numbers on our <a className="underline" href="https://homelet.co.uk/contact-us">Contact Us</a> page.
                            </p>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

export default ApplicationError;


/** WEBPACK FOOTER **
 ** ./src/components/Screens/ApplicationError.js
 **/